import { createTanstackQueryUtils } from "@orpc/tanstack-query";
import { apiClient } from "./orpc-client";

export const orpc = createTanstackQueryUtils(apiClient);
